CheckoutV2.PaymentV2.BraintreePayPal = function(checkout, $container) {
    var method = this;

    // minimum order total in dollars for offering credit
    this.minimumOfferCreditValue = 99;

	// id for new paypal payments
	this.NEW_PAYMENT_ID = 'NEW';

    this.data = {};
	this.paypalSelector = '.js-braintree-paypal-button';
	this.paypalCreditSelector = '.js-braintree-paypal-credit-button';
    this.paypalDetailSelector = '.js-paypal-detail-label';
    this.paypalValidationSelector = '.js-braintree-paypal-validation';
    this.templateName = 'includes/partials/payment/payPal.html';

    this.stepFailedListener = false;
    this.storedPayment = false;
    this.otherPayments = [];

    this._init = function() {
		var valid = false;
        if ( $container.hasClass( "js-paypal-stored" ) ) {
            var isPayPalPayment = function( payment ) {
                return payment.method.indexOf( "storedbtpaypal" ) == 0;
            };
            var storedPayments = checkout.session.get( "storedPayments" ) || [];
            var storedPayPalPayments = storedPayments.filter( isPayPalPayment );
            method.storedPayment = storedPayPalPayments[ 0 ];
            method.storedPaymentID = (storedPayPalPayments[ 0 ].method.split('-'))[1];
            method.templateName = 'includes/partials/payment/payPalStored.html';
            if ( storedPayPalPayments.length > 1 ) {
                method.otherPayments = storedPayPalPayments.slice( 1 );
            }
			var paymentMethod = checkout.payment.models.paymentMethodFromPaypal(checkout.cart.totals.values.remaining);
			paymentMethod.email = method.storedPayment.paypalEmail;
			paymentMethod.paypalEemail = method.storedPayment.paypalEmail;
			paymentMethod.storedPaymentID = method.storedPaymentID;
			checkout.payment.setActivePaymentMethods([paymentMethod]);
	        checkout.payment.onMethodValid();
			valid = true;
        }

        method._render();
		method.setNextStepButtonHtml();
		method.$paypalDetail = $container.find( method.paypalDetailSelector );


		if (!valid) {
        	method._setPaymentActiveMethods({}, checkout.cart.totals.values.remaining);
	        checkout.payment.onMethodInvalid();
		}

        method.stepFailedListener = function() { method._buttonReminder() };
        checkout.registerStepFailedListener( method.stepFailedListener );

		this._listen();
	};

    this._buttonReminder = function() {
        var $paypalValidation = $container.find( method.paypalValidationSelector );
        checkout.scrollToCenter( $container );
        if ( $paypalValidation.hasClass( "hide" ) ) {
            $paypalValidation.removeClass( "hide" );
        }
        else {
            $paypalValidation.fadeOut( 500 ).fadeIn( 250 );
        }
    };

    this._listen = function() {
        var $changePayPalAccount = $container.find( ".js-change-paypal-account" );
        $( method.paypalSelector ).on( 'click', function(e) { e.preventDefault() } );
        $( method.paypalCreditSelector ).on( 'click', function(e) { e.preventDefault() } );
        $changePayPalAccount.click( function(e) {
			e.preventDefault();
			checkout.payment.changeAccountModal.setAccountChangedCallback( method._onAccountChanged );
			checkout.payment.changeAccountModal.setCurrentAccount( method.storedPayment );
			checkout.payment.changeAccountModal.render();
			checkout.payment.changeAccountModal.show();
        } );
        $container.find( '.js-view-payment-method' ).click( function(e) {
			e.preventDefault();			
			var paymentID = $(e.target).data('id');
			var data;
			var paymentInfoURL = checkout.config.siteAbbr == 'ECS' ? '/MyAccount/PaymentInfo/' : '/MyAccount/PaymentInfo';
			var w = window.open( location.origin + paymentInfoURL );
			var errorShowingPaymentMethod = "Unable to open Payment Method URL";
			if (paymentID) {
				data = {
					action: 'get_payment_url',
					storedPaymentID: paymentID,
				};
				var newWindow;
				method.getPaymentPageRequest = $.ajax( {
					url        : paymentInfoURL,
					method     : 'POST',
					dataType   : 'json',
					data	   : data,
				} ).done( function( response ) {
					if (!response.payment_url) { 
						if (w) w.close();
						checkout.payment.showErrors( errorShowingPaymentMethod );
						return;
					}
					if (w) w.location = response.payment_url;
				} ).fail( function() {
					if (w) w.close();
					checkout.payment.showErrors( errorShowingPaymentMethod );
					return;
				} );
			} else {
				if (w) w.close();
				checkout.payment.showErrors( errorShowingPaymentMethod );
			}
		});
    };

    this._onAccountChanged = function(account) {
        var isPayPalPayment = function( payment ) {
            return payment.method.indexOf( "storedbtpaypal" ) == 0;
        };
        var storedPayPalPayments = checkout.session.get('storedPayments').filter( isPayPalPayment );
		var storedPayments = storedPayPalPayments.filter(function(acct) {
			var id = (acct.method.split('-'))[1];
			return id === account.id;
		});
		if (!storedPayments.length)  {
            checkout.payment.onMethodValid();
			return  null;
		}
		method.storedPayment = storedPayments[ 0 ];
		method.storedPaymentID = (storedPayments[0].method.split('-'))[1];
		method.templateName = 'includes/partials/payment/payPalStored.html';
        if ( storedPayPalPayments.length > 1 ) {
            method.otherPayments = storedPayPalPayments.slice( 1 );
        }
		if (method.data.nonce && account.id != method.data.nonce.replace(/-/g,'_')) {
			method.data.nonce = false;
		} else if (method.data.nonce && account.id == method.data.nonce.replace(/-/g,'_')) {
			method.storedPaymentID = false;
		}
        method._render();
		method._listen();

		var paymentMethod = checkout.payment.activeMethods[0];
		paymentMethod.email = method.storedPayment.paypalEmail;
		paymentMethod.paypalEmail = method.storedPayment.paypalEmail;
		paymentMethod.storedPaymentID = method.storedPaymentID;
		checkout.payment.setActivePaymentMethods([paymentMethod]);
		checkout.payment.onMethodValid();
	};

    this.addPayPalButton = function( credit, selector ) {
        var $wrapper = $container.find( selector );
        // whether to use checkout or vaulting, always use checkout
        // for now, otherwise set to the value of credit
        // var checkoutflow = credit;
        var checkoutflow = true;

        return window.braintree.paypalCheckout.create({
            client: checkout.payment.bt,
            merchantAccountId: checkout.config.braintreeMerchantAccountID
        }).then(function(paypalCheckout) {
            checkout.payment.paypalCheckout = paypalCheckout;
            fundingAllowed = credit ? paypal.FUNDING.CREDIT : paypal.FUNDING.CARD;
            fundingDisallowed = credit ? paypal.FUNDING.CARD : paypal.FUNDING.CREDIT;

            var shippingAddress = checkout.shipinfo.getFormData();
            var paypalShippingAddress = {
                line1: shippingAddress.shipping.address1,
                city: shippingAddress.shipping.city,
                state: shippingAddress.shipping.state,
                postalCode: shippingAddress.shipping.zip,
                countryCode: shippingAddress.shipping.country,
            };
            if (shippingAddress.shipping.address2)
                paypalShippingAddress.line2 = shippingAddress.shipping.address2;
            if (shippingAddress.shipping.phone)
                paypalShippingAddress.phone = shippingAddress.shipping.phone;
            if (shippingAddress.shipping.firstname) 
                paypalShippingAddress.recipientName = shippingAddress.shipping.firstname;
            if (shippingAddress.shipping.lastname) {
               if (paypalShippingAddress.recipientName)
                  paypalShippingAddress.recipientName = paypalShippingAddress.recipientName + ' ';
               else
                  paypalShippingAddress.recipientName = '';
               paypalShippingAddress.recipientName = paypalShippingAddress.recipientName + shippingAddress.shipping.lastname
            }

            $wrapper.show();

            return paypal.Button.render({
                funding: {
                    allowed: [fundingAllowed],
                    disallowed: [fundingDisallowed],
                },
                style: {
                    color: credit ? 'darkblue' : 'blue',
                    shape: 'rect',
                    fundingIcons: false,
                    size: 'responsive',
                    layout: 'horizontal',
                    tagline: false,
                    label: credit ? 'credit' : 'paypal',
                },
                env: checkout.config.braintreePayPalEnvironment,
                payment: function() {
					checkout.payment.hideErrors();
					var paypalCheckoutOptions = {
                        currency: 'USD',
                        offerCredit: credit,
                        flow: checkoutflow ? 'checkout' : 'vault',
                        intent: 'authorize',
                        enableShippingAddress: true,
                        shippingAddressEditable: false,
                        shippingAddressOverride: paypalShippingAddress,                        
                        displayName: checkout.config.siteName
                    };
					if (checkoutflow) {
                        paypalCheckoutOptions['amount'] =  checkout.cart.totals.values.total;
                    } else {
                        paypalCheckoutOptions['billingAgreementDescription'] = ' '; // The space is needed
                    }
                    var event_name = credit ? 'braintree-paypal-credit-button' : 'braintree-paypal-button';
					if (window.dataLayer)
						dataLayer.push({ event: event_name });
					return paypalCheckout.createPayment( paypalCheckoutOptions ).catch( function(e) { 
                        // this 'structure' is a mess, make sure everything is in place before invalidating shipinfo data
                        // attempt to pull paymentResource error from output, wrap in a try catch to avoid having to check every step
                        var paymentError;
                        try {
                            paymentError = e.details.originalError.details.originalError.paymentResource;
                        } catch(e) {
                           paymentError = false;
                        }
                
                        if (paymentError) {
                            if (paymentError.errorDetails && paymentError.errorDetails.length > 0) {
                                var shipinfoFieldErrors = [];
                                paymentError.errorDetails.forEach( function(fld) {
                                    if (checkout.shipinfo.fields[ fld.field ]) {
                                        shipinfoFieldErrors.push([ fld.field, fld.issue || "Invalid"  ]); 
                                    }
                                });
                                if (shipinfoFieldErrors.length > 0) {
                                    checkout.shipinfo.otherErrors = shipinfoFieldErrors;
                                    checkout.nextStep( false, 1 );
                                    // checkout.shipinfo.displayShippingAddress();
                                    var paypalError = "PayPal could not validate your shipping address. Please double check the fields highlighted below.";
                                    checkout.shipinfo.showErrors( paypalError );
                                    shipinfoFieldErrors.forEach( function(fieldError) {
                                        checkout.shipinfo.fieldError( checkout.shipinfo.fields[ fieldError[0] ], fieldError[1] );
                                    });
                                    checkout.shipinfo.valid = false;
                                }
                                throw( e );
                            }
                        }
                        throw(e);
                    } );
                },
                onError: function(err) {
                    // remove stack trace from error
                    var theError = err.errorMessage || err.message || err;
                    var aErrors = theError.split(/\n/);
                    theError = aErrors[0] || theError;
                    checkout.payment.showErrors( theError );
                    throw (err);
                },
                onAuthorize: function(data, actions) {
                    return paypalCheckout.tokenizePayment(data).then(function(payload) {
                        method.data.nonce = payload.nonce;
                        method.data.email = payload.details.email;
                        method.data.phone = payload.details.phone;
                        method.data.first_name = payload.details.firstName;
                        method.data.last_name = payload.details.lastName;
                        method.data.payerID = payload.details.payerId;
                        method.data.shippingAddress = payload.details.shippingAddress;
                        method.data.billingAddress = payload.details.billingAddress || payload.details.shippingAddress;
						// if (payload.creditFinancingOffered)
                        //	method.data.paypalCredit = payload.creditFinancingOffered;
						// else 
						method.data.paypalCredit = checkoutflow;
						method.storedPayment = {
							id:  method.data.nonce,
							paypalEmail: method.data.email,
							first_name: method.data.first_name,
							last_name: method.data.last_name,
							city: method.data.billingAddress.city,
							state: method.data.billingAddress.state,
							address: method.data.billingAddress.line1,
							address2: method.data.billingAddress.line2,
							zip: method.data.billingAddress.postalCode,
							country: method.data.billingAddress.countryCode,
							type: 'btpaypal',
							method: ['storedbtpaypal', method.data.nonce.replace(/-/g, '_')].join('-'),
							payment_amount: checkout.cart.totals.values.total,
						};
						method.storedPaymentID = method.data.nonce.replace(/-/g, '_');
                        method._setPaymentActiveMethods(method.data, checkout.cart.totals.values.remaining);
						method._render();
						method._listen();
                        checkout.payment.onMethodValid();
                        checkout.nextStep();
                    }).catch(function (e) { 
						console.log(error); console.log(e) 
						throw(e);
					});
                }
            }, $wrapper[0]);
        });
    };

    this._render = function() {
        var content = Jemplate.process( method.templateName, method );
        $container.find('.payment-method-paypal-container').html(content);
        $container.find('.collapse').addClass('show');
		$container.find('[data-toggle="popover"]').popover();
		checkout.payment.hideErrors();
        // only automatically show the paypal buttons if we
        // don't have a vaulted paypal account to use
        if ( ! method.storedPayment ) method._loadButtons();
    };

    this._loadButtons = function() {
        checkout.payment.loading("Connecting to PayPal");
        checkout.payment.getBT( function() {
            method.addPayPalButton( false, method.paypalSelector ).then( function() {
                var orderTotal = checkout.cart.totals.values.total;
                if ( orderTotal >= checkout.config.paypalOfferCreditAmount ) {
                    method.addPayPalButton( true,  method.paypalCreditSelector );
                }
            }).then(function() {
                checkout.payment.loading(false);
                // scroll to keep the payment method in sight on page
                var $btpaypal = $('input[value="btpaypal"]').closest('.card');
                var offset = $btpaypal.offset().top;
                var banner = $('body .js-skinny-header').css('position') == 'sticky' ? $('body .js-skinny-header').height() : 0;
                // scroll if the element does not fit on screen after selection
                if ( (offset + banner < $(window).scrollTop()) ||  (offset + $btpaypal.height() > $(window).height() - banner) ) {
                    $('html, body').animate(
                        {
                          scrollTop: offset - banner,
                        },
                        250,
                        'linear'
                    );
                }
            }).catch(function(err) {
                checkout.payment.loading(false);
            });
        });
    };

    // Sets the payment modules active methods
    this._setPaymentActiveMethods = function(amount) {
        var paymentMethod = checkout.payment.models.paymentMethodFromPaypal(amount);
		if (method.storedPayment) {
			paymentMethod.email = method.storedPayment.paypalEmail;
			paymentMethod.paypalEmail = method.storedPayment.paypalEmail;
			paymentMethod.address = method.storedPayment.address;
			paymentMethod.address2 = method.storedPayment.address2;
			paymentMethod.city = method.storedPayment.city;
			paymentMethod.country = method.storedPayment.country;
			paymentMethod.first_name = method.storedPayment.first_name;
			paymentMethod.last_name = method.storedPayment.last_name;
			paymentMethod.phone = method.storedPayment.phone;
			paymentMethod.state = method.storedPayment.state;
			paymentMethod.zip = method.storedPayment.zip;
			if (method.storedPayment.storedPaymentID) 
				paymentMethod.storedPaymentID = method.storedPayment.storedPaymentID;
			if (method.storedPayment.nonce) 
				paymentMethod.nonce = method.storedPayment.nonce;
			if (!paymentMethod.nonce && method.storedPayment.id && method.storedPayment.id.match(/-/))
				paymentMethod.nonce = method.storedPayment.id;
			if (!paymentMethod.nonce && method.storedPayment.id && !method.storedPayment.id.match(/-/))
				paymentMethod.storedPaymentID = method.storedPayment.id;
		}
		paymentMethod.storedPaymentID = paymentMethod.storedPaymentID || method.storedPaymentID;
        checkout.payment.setActivePaymentMethods([paymentMethod]);
    };

	// Called by checkout and the method to set the next step button text
    this.setNextStepButtonHtml = function() {
        checkout.payment.setNextStepCTA(checkout.getReviewStepCTA());
        checkout.payment.setNextStepButtonHtml(checkout.getReviewStepButtonHtml());
    };

    this.resetValidity = function ( payment ) {
		if ( payment.nonce || (payment.storedPaymentID && !payment.storedPaymentID.match(/[_-]/)) )
			checkout.payment.onMethodValid();
		else
			checkout.payment.onMethodInvalid();
    };

    this.resetStep = function() {
        $container.find('.payment-method-paypal-container').html('');
        method._setPaymentActiveMethods({}, checkout.cart.totals.values.remaining);
        checkout.payment.onMethodInvalid();
        method._render();
        method._listen();
    };

    this.destroy = function() {
        if ( method.stepFailedListener ) {
            checkout.removeStepFailedListener( method.stepFailedListener );
        }
    };

    this._init();
};
